import { useAuth } from '@phx-husky/use-auth';
import { useEffect, useState } from 'react';

import { authStore } from '~/services/store/authStore';

export const useAuthGuard = (enabled: boolean = true) => {
  const auth = useAuth();

  const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(() => {
    if (!enabled) return true;

    const user = authStore.getAuthUser();
    if (user === undefined) return null;

    return user !== null;
  });

  useEffect(() => {
    if (!enabled) return undefined;

    const timeout = setTimeout(() => {
      setIsLoggedIn((current) => (current === null ? false : current));
    }, 5000);

    const unsubscribe = authStore.subscribe((user) => {
      clearTimeout(timeout);
      setIsLoggedIn(user === undefined ? null : user !== null);
    });

    const currentUser = auth.getCurrentUser();
    if (currentUser !== undefined) {
      clearTimeout(timeout);
      setIsLoggedIn(currentUser !== null);
    }

    return () => {
      clearTimeout(timeout);
      unsubscribe();
    };
  }, [enabled]);

  return { isLoggedIn };
};
